import type { EditorPlay } from '../stores/dateLottery'

import { DATE_LOTTERY_FIELD_NAME } from '../constants/dateLottery'
import { findFieldIndexByName } from '../utils/editorFields'

type PrefillStore = {
  plays: EditorPlay[]
  setSelectedNumbers: (playId: string, fieldIndex: number, selected: number[]) => void
}

export const useDateLotteryPrefill = (store: PrefillStore) => {
  const { result } = useUserDataQuery()

  const dateOfBirth = computed(() => {
    const value = result.value?.player.dateOfBirth
    if (!value) return null

    const [year, month, day] = value.split('-')
    return { day: Number(day), month: Number(month), year: Number(year.slice(-2)) }
  })

  const setPart = (play: EditorPlay, name: string, value: number) => {
    const index = findFieldIndexByName(play, name)
    if (index < 0) return

    store.setSelectedNumbers(play.id, index, [value])
  }

  const apply = () => {
    const value = dateOfBirth.value
    const [play] = store.plays
    if (!value || !play) return
    if (play.fields.some(({ selected }) => selected.length)) return

    setPart(play, DATE_LOTTERY_FIELD_NAME.Month, value.month)
    setPart(play, DATE_LOTTERY_FIELD_NAME.Day, value.day)
    setPart(play, DATE_LOTTERY_FIELD_NAME.Year, value.year)
  }

  const prefillFirstPlay = () => {
    if (dateOfBirth.value) return apply()

    watchOnce(dateOfBirth, apply)
  }

  return { prefillFirstPlay }
}
